import FormSignUpStep12 from "./FormSignUpStep12";

export default FormSignUpStep12;
